import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Button } from '@blueprint/ui';
import { FormFooter } from "../../common/components/form";

import PublicFormContainer from "./components/PublicFormContainer";
import { useParams } from "react-router-dom";

import { publicUserAPI } from "../../api/publicUser";
import { useGeneralErrorHandlerCreator } from "../../common/hooks/useGeneralErrorHandler";
import { GenericError, composeErrorHandlers } from "../../utils/errorHandling";


enum ResetOTPState {
    Processing,
    Success,
    Invalid,
}

const ResetOTPView = (): JSX.Element => {

    const [state, setState] = useState(ResetOTPState.Processing);

    const { token } = useParams<{ token: string }>();

    const useGeneralError = useGeneralErrorHandlerCreator();

    useEffect(() => {
        const reset = async () => {
            setState(ResetOTPState.Processing);
            try {
                await publicUserAPI.resetOTP(token);
            } catch (err) {
                console.log(err)
                composeErrorHandlers(useGeneralError)(err as GenericError);
                setState(ResetOTPState.Invalid);
                return;
            }
            setState(ResetOTPState.Success);
        }
        reset();
        return () => {
            setState(ResetOTPState.Processing);
        }
    }, [token, useGeneralError]);

    switch (state) {
        case ResetOTPState.Processing:
            return <ResetOTPForm />;
        case ResetOTPState.Success:
            return <ResetOTPSuccessMessage />;
        case ResetOTPState.Invalid:
            return <ResetOTPInvalidMessage />;
    }
};

const ResetOTPForm = (): JSX.Element => {
    return (
        <PublicFormContainer>
            <h2 className="mb-4">
                2 Factor Authentication Reset
            </h2>
            <p className="mb-5">
                Please wait for a moment while we reset your 2 Factor Authentication ...
            </p>
        </PublicFormContainer>
    );
};

const ResetOTPSuccessMessage = (): JSX.Element => {
    return (
        <PublicFormContainer>
            <h2 className="mb-4">2 Factor Authentication has been reset</h2>
            <p className="mb-5">
                Your 2 Factor Authentication has been reset. Please login again and scan the new QR code to activate it.
            </p>
            <FormFooter className="d-flex mb-5">
                <NavLink
                    to="/login"
                >
                    <Button
                        type="submit"
                        variant="light.primary">Back To Login</Button>
                </NavLink>
            </FormFooter>
        </PublicFormContainer>
    );
};

const ResetOTPInvalidMessage = (): JSX.Element => {
    return (
        <PublicFormContainer>
            <h2 className="text-secondary mb-4">Invalid Link</h2>
            <p className="mb-5">
                This link may be used or expired. Please restart the 2 Factor Authentication reset process for a new link.
            </p>
            <FormFooter className="d-flex mb-5">
                <NavLink
                    to="/login"
                >
                    <Button
                        type="submit"
                        variant="light.primary">Back To Login</Button>
                </NavLink>
            </FormFooter>
        </PublicFormContainer>
    );
};

export default ResetOTPView;
